export default __webpack_public_path__ + "static/media/veg_n_fish.3ff8592f.jpg";